import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Sarah Jenkins",
  quote: "The care Happy Paws provided for my golden retriever during his surgery was exceptional. They treated him like family.",
  position: "Pet Parent to Buddy",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/testimonial_dog_buddy.png"
}, {
  author: "Michael Chen",
  quote: "Finding a vet that truly understands feline anxiety was a game changer. Our visits are now stress-free and calm.",
  position: "Pet Parent to Luna",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/testimonial_cat_luna.png"
}];
export default function WhyFamiliesTrustUs() {
  return <section data-section-id="240382" id="why-families-trust-us" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary)_0%,transparent_40%)] opacity-5 pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,var(--color-primary)_0%,transparent_40%)] opacity-5 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="relative px-6 py-12 md:px-16 md:py-20 flex flex-col items-center text-center min-h-[400px] justify-center bg-card rounded-3xl shadow-lg border border-border/50">
                    {}
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-5 pointer-events-none rounded-3xl blur-3xl" />

                    <Quote className="size-10 md:size-12 text-primary/40 mb-8 md:mb-12" />
                    
                    <p className="font-default font-semibold text-2xl md:text-3xl lg:text-4xl leading-relaxed text-foreground mb-12 max-w-4xl relative z-10 tracking-tight">
                      "{testimonial.quote}"
                    </p>

                    <div className="flex items-center gap-4 relative z-10">
                      <SafeHydrate><Avatar className="size-14 md:size-16 border-2 border-primary/20 shadow-sm">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                        <AvatarFallback className="bg-primary/10 text-primary font-default text-lg">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-left">
                        <div className="font-default font-bold text-foreground text-lg">
                          {testimonial.author}
                        </div>
                        <div className="font-default text-sm text-muted-foreground">
                          {testimonial.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="flex justify-end gap-3 mt-8 pr-4 md:pr-16">
              <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 bg-white border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-sm rounded-md" />
              <CarouselNext className="static translate-y-0 translate-x-0 size-12 bg-white border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-sm rounded-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}